module.exports = __webpack_public_path__ + "img/bi_tit.78de4208.png";